import React, { useState, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const API_URL = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');

export default function LearnerView({ token }) {
  const { logout } = useAuth0();
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/lessons/assigned`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setLessons(data.lessons);
          if (data.lessons.length > 0) setSelectedLesson(data.lessons[0]);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [token]);

  const buildIframeSrc = (templateId) => {
    return `${API_URL}/lesson.html?template=${encodeURIComponent(templateId)}&_t=${Date.now()}&preview=true&session_token=${encodeURIComponent(token)}`;
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0f172a', color: '#e2e8f0' }}>
      <div>Loading your lessons...</div>
    </div>
  );

  if (lessons.length === 0) return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0f172a', color: '#e2e8f0' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📚</div>
        <h2 style={{ margin: '0 0 8px' }}>No lessons assigned</h2>
        <p style={{ color: '#94a3b8' }}>Your instructor hasn't assigned any lessons yet.</p>
        <button
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          style={{ marginTop: '16px', padding: '8px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
        >
          Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#0f172a', fontFamily: 'inherit' }}>

      {/* ── Left sidebar — lesson list ── */}
      <div style={{
        width: '260px', minWidth: '260px', background: '#1e1b4b',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
      }}>
        <div style={{ padding: '20px 16px 14px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: '16px', fontWeight: 800, color: '#a5b4fc' }}>My Lessons</div>
          <div style={{ fontSize: '11px', color: '#818cf8', marginTop: '2px' }}>{lessons.length} assigned</div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '8px' }}>
          {lessons.map(lesson => (
            <div
              key={lesson.template_id}
              onClick={() => setSelectedLesson(lesson)}
              style={{
                padding: '12px 14px', borderRadius: '10px', cursor: 'pointer',
                marginBottom: '4px',
                background: selectedLesson?.template_id === lesson.template_id
                  ? 'rgba(99,102,241,0.3)' : 'transparent',
                border: selectedLesson?.template_id === lesson.template_id
                  ? '1px solid rgba(99,102,241,0.5)' : '1px solid transparent',
              }}
            >
              <div style={{ fontSize: '13px', fontWeight: 600, color: '#e2e8f0' }}>
                {lesson.name || lesson.template_id}
              </div>
              {lesson.description && (
                <div style={{
                  fontSize: '11px', color: '#94a3b8', marginTop: '4px',
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {lesson.description}
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            style={{
              width: '100%', padding: '8px', background: 'none',
              border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px',
              color: '#94a3b8', cursor: 'pointer', fontSize: '12px',
            }}
          >
            Sign out
          </button>
        </div>
      </div>

      {/* ── Main lesson iframe ── */}
      <div style={{ flex: 1, position: 'relative' }}>
        {selectedLesson ? (
          <iframe
            ref={iframeRef}
            key={selectedLesson.template_id}
            src={buildIframeSrc(selectedLesson.template_id)}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title={selectedLesson.name}
          />
        ) : (
          <div style={{ display: 'grid', placeItems: 'center', height: '100%', color: '#94a3b8' }}>
            Select a lesson to start
          </div>
        )}
      </div>
    </div>
  );
}
